import React from 'react';
import { ThemeProvider, createTheme, CssBaseline, Box } from '@mui/material';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import Services from './components/Services';
import Fleet from './components/Fleet';
import PopularRoutes from './components/PopularRoutes';
import WhyUs from './components/WhyUs';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';
import './i18n';

// SEO için tema renkleri
const theme = createTheme({
  palette: {
    primary: {
      main: '#424242',
      light: '#6d6d6d',
      dark: '#1b1b1b',
    },
    secondary: {
      main: '#c5a47e',
      light: '#d4b898',
      dark: '#b69164',
    },
    background: {
      default: '#ffffff',
      paper: '#fafafa',
    },
    text: {
      primary: '#424242',
      secondary: '#757575',
    },
    grey: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#eeeeee',
      300: '#e0e0e0',
      400: '#bdbdbd',
      500: '#9e9e9e',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121',
    },
  },
  typography: {
    fontFamily: '"Poppins", "Arial", sans-serif',
    h1: {
      fontWeight: 600,
      letterSpacing: 1,
    },
    h2: {
      fontWeight: 600,
      letterSpacing: 0.5,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0px 4px 12px rgba(197, 164, 126, 0.25)',
            transform: 'translateY(-2px)',
            transition: 'all 0.3s ease',
          },
        },
        containedSecondary: {
          background: 'linear-gradient(45deg, #c5a47e 30%, #d4b898 90%)',
          '&:hover': {
            background: 'linear-gradient(45deg, #b69164 30%, #c5a47e 90%)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          transition: 'all 0.3s ease',
          '&:hover': {
            boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.1)',
          },
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ overflowX: 'hidden', width: '100%' }}>
        <Navbar />
        <main>
          <HeroSection />
          <Services />
          <Fleet />
          <PopularRoutes />
          <WhyUs />
          <ContactForm />
        </main>
        <Footer />
        <FloatingButtons />
      </Box>
    </ThemeProvider>
  );
}

export default App;
